import { lazy, Suspense, useState } from 'react';
import { useLocation } from 'react-router-dom';

import type { LexSelectionContext } from '../../types/runtime';
import { LexSelectionPopover } from './LexSelectionPopover';
const MatterIntelligenceCaptureDialog = lazy(() => import('./MatterIntelligenceCaptureDialog').then((module) => ({ default: module.MatterIntelligenceCaptureDialog })));

export function GlobalMatterIntelligenceCapture() {
  const location = useLocation();
  const [selection, setSelection] = useState<LexSelectionContext | null>(null);
  const [notice, setNotice] = useState<string | null>(null);
  // /chat mounts the full selection popover itself; the EdgeDocs editor's Lex
  // panel does the same (EDGEDOCS_SELECTION_ACTIONS 2026-07-14) — mounting the
  // MI-only popover there too would stack two popovers on one selection.
  if (
    import.meta.env.VITE_EDGELEX_MATTER_CONTEXT_CAPTURE === 'false'
    || location.pathname.startsWith('/chat')
    || location.pathname.startsWith('/dms/editor')
    || /\/documents\/[^/]+\/editor(?:$|\/)/.test(location.pathname)
  ) return null;
  const matterIdFromRoute = location.pathname.match(/\/matters\/([0-9a-f-]{36})/i)?.[1] ?? null;

  return (
    <>
      <LexSelectionPopover matterIntelligenceOnly onAction={(action, next) => {
        if (action === 'matter_intelligence') setSelection(next);
      }} />
      {selection && <Suspense fallback={null}><MatterIntelligenceCaptureDialog open={Boolean(selection)} selection={selection} initialMatterId={matterIdFromRoute} onClose={() => setSelection(null)} onSaved={message => { setNotice(message); window.setTimeout(() => setNotice(null), 3500); }} /></Suspense>}
      {notice && <div className="fixed bottom-5 left-1/2 z-[1300] -translate-x-1/2 rounded-lg border bg-white px-4 py-2 text-sm shadow-lg dark:bg-slate-900">{notice}</div>}
    </>
  );
}
